export const GET_UNREAD_MESSAGES = "GET_UNREAD_MESSAGES";

export const GetUnreadMessages = () => {
    return { type: GET_UNREAD_MESSAGES };
};
